import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { CompaniesProvider } from '@modeso/aumico-lib-companies-fe';
import Debug from 'debug';
import { Observable, tap } from 'rxjs';
import { Paths } from '../../../enums/paths.enum';
const debug = Debug('aumico:project-reports-fe:IdValidatorGuard');
@Injectable({
    providedIn: 'root',
})
export class IdValidatorGuard implements CanActivate {
    constructor(
        private companiesProvider: CompaniesProvider,
        private router: Router, // Inject the Router service
    ) {}

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        const id = route.paramMap.get('companyId');
        return this.companiesProvider.isCompanyUrlIdValid$(id).pipe(
            tap((isValid) => {
                if (!isValid) {
                    this.router.navigate([`/${Paths.NOT_FOUND}`]);
                }
            }),
        );
    }
}
